import React from 'react'

import { FacebookPixel, GoogleAnalytics, Heap, HelpScout } from '../../../../services'

import useTrackPage from './useTrackPage'
import useTrackIdentity from './useTrackIdentity'

const Utils = () => {
  useTrackPage()
  useTrackIdentity()

  return (
    <>
      <FacebookPixel.Scripts />
      <GoogleAnalytics.Scripts />
      <Heap.Scripts />
      <HelpScout.Scripts />
    </>
  )
}

export default Utils
